import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';

@Component({
  selector: 'app-clear-cache',
  templateUrl: './clear-cache.component.html',
  styleUrls: ['./clear-cache.component.css']
})
export class ClearCacheComponent implements OnInit {

  public entities: string[];
  public isLoading = false;

  constructor(private apiSvc: ApiService) { }

  ngOnInit() {
    this.getCurrentCache();
  }

  public getCurrentCache() { 
 
    this.isLoading = true;
    this.apiSvc.get("api/cache/getCache", null).subscribe(
      (data: string[]) => { 
        console.log(data); 
        this.entities = data;
        this.isLoading = false;
      },
      (err) => {
        console.log("error", err);
        this.isLoading = false;
      }
    );
  }


  public clearCache() { 

    console.log("clearing cache");
    this.apiSvc.post("api/cache/clearCache", null).subscribe(
      (data: string) => {

        this.getCurrentCache();
        
        alert(data);
        console.log(data); 
      },
      (err) => {
        console.log("error", err);
      }
    );
  }
 
}
